// ============================================================================
// src/pig/pigRoutes.ts — the pig domain's route table.
// ============================================================================
// B3.1 finish, fifth domain and the largest: seven views. Same shape as the
// cattle, sheep, layer and broiler tables.
//
// Two view strings do not read like their paths, and both are load-bearing
// history rather than mistakes:
//
//   'pigs'     -> /pig/feed   the current view string for PigFeedView
//   'breeding' -> /pig/breeding, 'farrowing' -> /pig/farrowing
//              unprefixed view strings from before the domain had a prefix
//
// Renaming them is not this commit's job -- the view strings are the mechanism
// the URL adapter, the Header, globalNav and the access predicates all speak.
// The table records the mapping that already exists.
//
//   /pig/dailys/<id>   PigDailysView — daily record page
//   /pig/batches/<id>  PigBatchesView — batch record page
//   /pig/sows/<id>     SowsView — sow record page
//
// '/pig', '/pig/feed' and '/pig/breeding' are exact; farrowing includes records.
// ============================================================================

export const PIG_ROUTES = [
  {view: 'pigdailys', paths: ['/pig/dailys/*']},
  {view: 'pigs', paths: ['/pig/feed']},
  {view: 'pigsHome', paths: ['/pig']},
  {view: 'breeding', paths: ['/pig/breeding']},
  {view: 'pigbatches', paths: ['/pig/batches/*']},
  {view: 'farrowing', paths: ['/pig/farrowing/*']},
  {view: 'sows', paths: ['/pig/sows/*']},
];
